import { AuthContextType } from "../../types/types";
import axios from "axios";

export class EnvironmentRegistry {
    public static readonly KPI_SERVICE_URL = "https://kpi.sellina.io";
    public static readonly DATASTREAM_SERVICE_URL = "https://datastream-stg.salescode.ai";

    private static registry: Record<string, string> = {
        "local": "http://localhost:8080",
        "dev": "https://dev.sellina.io",
        "uat": "https://uat.salescode.ai",
        "demo": "https://demo.salescode.ai",
        "prod": "https://prod.salescode.ai",
        "prod-egtm": "https://prod-egtm.sellina.io",
        "prod-us-west": "https://prod-us-west.salescode.ai",
        "prod-eu-south": "https://prod-eu-south.salescode.ai"
    }
    private static authRegistry: Record<string, string> = {
        "local": "http://localhost:8083",
        "dev": "https://dev-auth.salescode.ai",
        "uat": "https://dev-auth.salescode.ai",
        "demo": "https://auth-demo.salescode.ai",
        "prod": "https://auth.salescode.ai",
        "prod-egtm": "https://auth.salescode.ai",
        "prod-us-west": "https://auth-us-west.salescode.ai",
        "prod-eu-south": "https://auth-eu-south.salescode.ai"
    }

    private static promoregistry: Record<string, string> = {
        "local": "http://localhost:8087",
        "dev": "https://promos-dev.salescode.ai",
        "uat": "https://promos-uat.salescode.ai",
        "demo": "https://promos-demo.salescode.ai",
        "prod": "https://promos-prod.salescode.ai",
        "prod-egtm": "",
        "prod-us-west": "https://promos-prod-us-west.salescode.ai",
        "prod-eu-south": ""
    }

    private static stockregistry: Record<string, string> = {
        "local": "http://localhost:8080",
        "dev": "https://stocks-dev.salescode.ai",
        "uat": "https://stocks-uat.salescode.ai",
        "demo": "https://stocks-demo.salescode.ai",
        "prod": "https://stocks-prod.salescode.ai",
        "prod-egtm": "",
        "prod-us-west": "",
        "prod-eu-south": ""
    }

    private static claimregistry: Record<string, string> = {
        "local": "http://localhost:8080",
        "uat": "https://claims-uat.salescode.ai",
        "demo": "https://claims-demo.salescode.ai",
        "prod": "https://claims-prod.salescode.ai",
        "prod-egtm": "",
        "prod-us-west": "",
        "prod-eu-south": ""
    }

    private static rewardsRegistry: Record<string, string> = {
        "uat": "https://rewardsuat.sellina.io",
        "demo": "https://rewardsdemo.sellina.io",
        "prod": "https://rewardsprod.sellina.io",
        "prod-us-west": "https://rewards-us-west.salescode.ai",
        "prod-eu-south": "https://rewards-eu-south.salescode.ai"
    }

    private static loadOutRegistry: Record<string, string> = {
        "local": "http://localhost:8081",
        "uat": "https://loadout-uat.salescode.ai",
        "demo": "https://loadout-demo.salescode.ai",
        "prod": "https://loadout-prod.salescode.ai",
        "prod-eu-south": ""
    }

    private static salesAgentRegistry: Record<string, string> = {
        "uat": "https://dev-salesagent.salescode.ai",
        "demo": "https://demo-salesagent.salescode.ai",
        "prod": "https://salesagent.salescode.ai",
    }

    private static insightsRegistry: Record<string, string> = {
        "dev": "https://insights-uat.salescode.ai",
        "uat": "https://insights-uat.salescode.ai",
        "demo": "https://insights.salescode.ai",
        "prod": "https://insights.salescode.ai"
 
    }

    private static reportRegistry: Record<string, string> = {
        "local": "http://localhost:8081",
        "demo": "https://reportsdemo.salescode.ai",
        "prod": "https://reportsprod.salescode.ai",
        "prod-us-west": "https://reportsprod-us-west.salescode.ai"
    }

    public static getloadoutBaseUrl = ()=>{
        const env = this.getEnvironment();
        if(!env){
            throw Error("env not set");
        }
        if(EnvironmentRegistry.loadOutRegistry[env]){
            return EnvironmentRegistry.loadOutRegistry[env];
        }else{
            throw Error("env not registered");
        }
    }

    public static getDatastreamUrl = () => {
        return this.DATASTREAM_SERVICE_URL;
    }


    private static smartTriggerRegistry: Record<string, string> = {
        "local": "http://localhost:8088"
    }

    static getSmartTriggerServiceUrl(env: string) {
        const url = this.smartTriggerRegistry[env]
        if (!url) {
            throw new Error("Could not find smart trigger service url for environment" + env)
        }
        return url;
    }

    static getRewardsUrl() {
        const env = this.getEnvironment();
        const url = this.rewardsRegistry[env ?? ""];
        if (!url) {
            throw new Error(`Environment "${env}" is not valid.`);
        }
        return url;
    }

    static getServerUrl() {
        const env = this.getEnvironment();
        return this.getUrl(env ?? "");
    }

    static getPromoServiceUrl() {
        const env = this.getEnvironment();
        return this.getPromoUrl(env ?? "");
    }

    static getReportServiceUrl() {
        const env = this.getEnvironment();
        return this.getReportUrl(env ?? "");
    }

    static getStockBaseUrl() {
        const env = this.getEnvironment();
        return this.getStockUrl(env ?? "");
    }

    static getClaimBaseUrl() {
        const env = this.getEnvironment();
        return this.getClaimUrl(env ?? "");
    }

    public static tokenRegistry: Record<string, string> = {
        "local": "",
        "dev": "",
        "uat": "",
        "demo": "",
        "prod": "",
        "prod-egtm": ""
    }
    static getToken(env: string) {
        const token = this.tokenRegistry[env];
        if (!token) {
            throw new Error("Token unavailable" + env)
        }
        return token;
    }
    static setToken(env: string, token:string){
        this.tokenRegistry[env] = token;
    }

    public static configCmpRefUrlRegistry: Record<string, { url: string; uniqueAttr: string,excludedKeys?:string[] }> = {
        transformers: {
            url: "/v1/transformers",
            uniqueAttr: "name",
        },
        query: {
            url: "/v1/query/info",
            uniqueAttr: "name",
        },
        clientConfig: {
            url: "/metadata",
            uniqueAttr: "domainName,domainType",
        },
        enrichments: {
            url: "/v1/enrichments",
            uniqueAttr: "id",
        },
        validations: {
            url: "/v1/registry/data/RuleInfo",
            uniqueAttr: "id",
        },
         clientProperties: {
            url: "/metadata/client",
            uniqueAttr: "domainName",
        },
        profiles: {
            url: "/profiles",
            uniqueAttr: "name",
        },
    };

    static getConfigRefAttr(configCategory: string): string {
        const configRefUrl = this.configCmpRefUrlRegistry[configCategory].uniqueAttr;
        if (!configRefUrl) {
            throw new Error("No config category");
        }
        return configRefUrl;
    }

    private static commonExcludedKeys:string[]=["createdBy","modifiedBy","creationTime","lastModifiedTime","lob"];
    
    public static getExcludedKeys(entityName:string):string[]{
        const excludedKeys = EnvironmentRegistry.configCmpRefUrlRegistry[entityName].excludedKeys || [];
        return [...EnvironmentRegistry.commonExcludedKeys, ...excludedKeys];
    }

    static getConfigRefUrl(configCategory: string): string {
        const configRefUrl = this.configCmpRefUrlRegistry[configCategory].url;
        if (!configRefUrl) {
            throw new Error("No config category");
        }
        return configRefUrl;
    }

    static getUrl(env: string) {
        const url = this.registry[env];
        if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }

    static getPromoUrl(env: string) {
        const url = this.promoregistry[env];
        if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }

    static getStockUrl(env: string) {
        const url = this.stockregistry[env];
        if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }

    static getClaimUrl(env: string) {
        const url = this.claimregistry[env];
        if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }
    

    static getKpiUrl(env: string) {
        env = env.toLowerCase();
        if (env === 'local') {
            return "http://localhost:8086";
        }
        return this.KPI_SERVICE_URL;
    }

    static getReportUrl(env: string) {
        const url = this.reportRegistry[env];
        if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }

    static getUrlFromContext(context: AuthContextType) {
        return this.getUrl(context.env);
    }

    static makeAuthHeaders(token: string) {
        return {
            Authorization: token
        }
    }

    static makeAuthHeadersFromContext(context: AuthContextType) {
        return {
            Authorization: context.token
        }
    }

    static async getLobs(env: string): Promise<string[]> {
        const url = EnvironmentRegistry.getUrl(env.toLowerCase());
        const response = await axios.get(url + "/hckeck");
        return response.data.systemInfo.lobNames
    }

    static setEnvironment(url:string){
        const env = Object.keys(this.registry).find(environment=>this.registry[environment] === url);
        if(env){
            localStorage.setItem("env",env);
        }
    }

    static getEnvironment(){
        return localStorage.getItem("env");
    }

    static getCurrentLob(){
        return localStorage.getItem("lob")
    }

    static getAuthUrl(env:string){
         const url = this.authRegistry[env];
         if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }

    static getSalesAgentUrl(env:string){
        const url = this.salesAgentRegistry[env];
        if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }

    static getInsightsUrl(env:string){
         const url = this.insightsRegistry[env];
         if (!url) {
            throw new Error("Invalid environment:" + env)
        }
        return url;
    }
}
